import { forwardRef } from 'react'
import { ThemeColor } from 'utils/colors'
import Box, { BoxProps } from '../Box'

interface Props extends Omit<BoxProps, 'color'> {
  children?: React.ReactNode
  isColumn?: boolean
  color?: ThemeColor
}

const Flex = forwardRef<HTMLDivElement, Props>(
  (
    {
      children,
      isColumn = false,
      flexDirection = isColumn ? 'column' : 'row',
      color,
      gap = '1rem',
      alignItems = isColumn ? 'start' : 'center',
      ...props
    },
    ref,
  ) => (
    <Box
      ref={ref}
      display="flex"
      gap={gap}
      flexDirection={flexDirection}
      color={color}
      alignItems={alignItems}
      {...props}
    >
      {children}
    </Box>
  ),
)

export default Flex
